import { useDocumentTitle } from "@/shared/hooks/useDocumentTitle";
export default function AdminSupport() {
	useDocumentTitle("Admin Support");
	return (
		<div className="p-4">
			<h1 className="text-lg mb-6">Support</h1>
			<div className="space-y-4">
				<div className="h-24 rounded-lg bg-muted animate-pulse" />
				<div className="h-24 rounded-lg bg-muted animate-pulse" />
			</div>
		</div>
	);
}
